import { Grid, styled } from '@mui/material';

export const Form = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: theme.spacing(2.5),
}));

export const LoginBanner = styled('div')(({ theme }) => ({
  height: '100vh',
  backgroundSize: 'cover',
  backgroundAttachment: 'fixed',
  backgroundColor: theme.palette.primary.dark,
  backgroundBlendMode: 'multiply',
}));

export const LoginContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  minHeight: '100vh',
  alignItems: 'center',
  backgroundColor: theme.palette.background.default,
}));

export const LoginFormBottomContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(1),
  flexWrap: 'wrap',
}));
